import {
  Column,
  IconButton,
  LabeledTextarea,
  Row,
  Label,
  LabeledTextareaProps,
} from 'components/Blocks';

import { FileUpIcon, XIcon } from 'components/Icons';
import { FileIconInput } from 'components/Uploads';
import { USE_FILE_LIMIT, UseFileInput } from 'hooks';

import { fixFileName, truncateText } from 'utils/text';

type FileInputProps = Pick<
  UseFileInput,
  'fileLimitReached' | 'files' | 'onPaste' | 'onFileInput' | 'removeFile'
> & {
  fileLimit?: number;

  getFileInput?: (props: Pick<UseFileInput, 'onFileInput'>) => JSX.Element;
};

type TextareaWithFilesProps = FileInputProps & LabeledTextareaProps;

export function TextareaWithFiles({
  onPaste,
  removeFile,
  onFileInput,
  files,
  fileLimitReached,
  fileLimit = USE_FILE_LIMIT,

  getFileInput,

  label,
  ...textAreaProps
}: TextareaWithFilesProps) {
  return (
    <Column>
      <LabeledTextarea
        label={
          <>
            {label}

            {!fileLimitReached &&
              (getFileInput?.({ onFileInput }) || (
                <FileIconInput onChange={onFileInput} className="ml-auto" />
              ))}
          </>
        }
        onPaste={onPaste}
        {...textAreaProps}
      />

      {!!files.length && (
        <Column gap="2">
          <Column gap="1">
            <Label>Files</Label>
            <span className="muted text-xxs">Up to {fileLimit}</span>
          </Column>

          <Row flexWrap="wrap">
            {files.map(({ file, url }, index) => (
              <div key={file.lastModified} className="group relative size-20 rounded-lg border">
                {file.type.startsWith('image/') ? (
                  <img src={url} alt="" className="size-full rounded-lg object-cover" />
                ) : (
                  <Column gap="1" alignItems="center" justifyContent="center" className="size-full">
                    <FileUpIcon />

                    <span className="px-1 text-center text-xxs">
                      {truncateText(fixFileName(file.name), 15)}
                    </span>
                  </Column>
                )}

                <IconButton
                  color="destructive"
                  variant="filled"
                  size="small"
                  className="absolute -right-2 -top-2 hidden p-0.5 text-destructive-foreground group-hover:block phone:block"
                  onClick={() => removeFile(index)}
                >
                  <XIcon size={12} />
                </IconButton>
              </div>
            ))}
          </Row>
        </Column>
      )}
    </Column>
  );
}
